import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { VideoElementComponent } from './video-element/video-element.component';
import { SwitchViewButtonComponent } from './switch-view-button/switch-view-button.component';
import { SelectBarComponent } from './select-bar/select-bar.component';
import { BadgeComponent } from './badge/badge.component';
import { ButtonComponent } from './button/button.component';
import { SwitchComponent } from './switch/switch.component';
import { FooterComponent } from './footer/footer.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { SelectBarTwoComponent } from './select-bar-two/select-bar-two.component';
import { CounterComponent } from './counter/counter.component';
import { CodesDivComponent } from './codes-div/codes-div.component';
import { MainLoaderComponent } from './main-loader/main-loader.component';
import { SmallLoaderComponent } from './small-loader/small-loader.component';
import { PatientInfoListComponent } from './patient-info-list/patient-info-list.component';
import { PatientCaseCardComponent } from './patient-case-card/patient-case-card.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { EmptyResultComponent } from './empty-result/empty-result.component';
import { PatientStatsCardComponent } from './patient-stats-card/patient-stats-card.component';
import { PatientSurveyCardComponent } from './patient-survey-card/patient-survey-card.component';
import { ServerErrorComponent } from './server-error/server-error.component';
import { ServerErrorControlComponent } from './server-error-control/server-error-control.component';

@NgModule({
  declarations: [
    VideoElementComponent,
    SwitchViewButtonComponent,
    BadgeComponent,
    SelectBarComponent,
    ButtonComponent,
    SwitchComponent,
    FooterComponent,
    NotificationsComponent,
    SearchBarComponent,
    SelectBarTwoComponent,
    CounterComponent,
    CodesDivComponent,
    MainLoaderComponent,
    SmallLoaderComponent,
    PatientInfoListComponent,
    PatientCaseCardComponent,
    ChangePasswordComponent,
    EmptyResultComponent,
    PatientStatsCardComponent,
    PatientSurveyCardComponent,
    ServerErrorComponent,
    ServerErrorControlComponent
  ],

  exports: [VideoElementComponent,
    SwitchViewButtonComponent,
    SelectBarComponent,
    ButtonComponent,
    SwitchComponent,
    NotificationsComponent,
    SearchBarComponent,
    SelectBarTwoComponent,
    FooterComponent,
    CounterComponent,
    CodesDivComponent,
    MainLoaderComponent,
    SmallLoaderComponent,
    PatientInfoListComponent,
    PatientCaseCardComponent,
    ChangePasswordComponent,
    EmptyResultComponent,
    PatientStatsCardComponent,
    PatientSurveyCardComponent,
    ServerErrorComponent,
    ServerErrorControlComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class SharedModule { }
